<template>
  <a class="company-card-main" :href="`/company/${data.token}.html`" target="_blank">
    <div class="flex">
      <div class="company-picture">
        <img :src="data.company_logo || data.logo" alt="">
      </div>
      <div class="company-content-box">
        <p class="title" :style="{marginBottom: data.suggestions ? '8px' : '14px'}">{{ data.company_name }}</p>
        <p class="type">
          <span v-if="data.industry">{{ data.industry }}</span>
          <span v-if="data.company_type ">{{ data.company_type }}</span>
          <span v-if="data.scale">{{ data.scale }}</span>
        <p class="desc" v-if="data.description">{{data.description}}</p>
      </div>
      <!-- <div class="interpolate-jobs">
        <p class="job-num">{{data.favorite_total}}</p>
        <p class="job-desc" style="width: 100px;">位用户帮你内推</p>
      </div> -->
      <div class="interpolate-jobs">
        <p class="job-num">{{data.job_total}}</p>
        <p class="job-desc" style="width: 58px;">在招职位</p>
      </div>
    </div>
    <div class="welfare-tag-box" v-if="welfare.length">
      <span v-for="item in welfare" :key="item" class="welfare-tag-item">{{item}}</span>
    </div>
  </a>
</template>
<script>
  import {benefit_options} from "@/assets/js/benefit_options"
  import {getCompanyScale} from '@/assets/js/util';
  
  export default {
    name: 'companyItem',
    props: {
      data: {
        type: Object
      }
    },
    data(){
      return {

      }
    },
    computed:{
      welfare(){
        try {
          let { benefit } = JSON.parse(JSON.stringify(this.data))
          if(!benefit || !benefit.length){
            return []
          } else{
            let tempList = benefit.map(item=>{
              let ids = item.list.map(id => id.id)
              let list = benefit_options[item.id].list.filter(obj => ids.includes(obj.id)).map(obj=> obj.label)
              return list
            })
            return tempList.flat(2)
          }
        }catch (e) {
          console.log(e)
          return []
        }
      }
    },
    methods:{
      getCompanyScale,
    },

  }
</script>
<style lang="scss" scoped>
  .company-card-main {
    box-sizing: border-box;
    padding: 18px 32px;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 6px;
    width: 882px;
    display: block;
    &:hover {
      box-shadow: 0px 2px 28px 0px rgba(10, 44, 156, 0.1);
    }
    .flex{
      display: flex;
      .company-picture{
        width: 70px;
        height: 70px;
        margin-right: 16px;
        &> img{
          width: 70px;
          height: 70px;
          border-radius: 6px;
        }
      }
      .company-content-box{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 42px;
        .title{
          font-size: 18px;
          font-weight: 500;
          color: #404040;
          margin-bottom: 8px;
        }
        .type{
          font-size: 13px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 14px;
          margin-bottom: 10px;

          >span {
            position: relative;
            margin-right: 13px;

            &::after {
              content: "";
              position: absolute;
              top: 50%;
              right: -7px;
              transform: translateY(-50%);
              width: 1px;
              height: 10px;
              background: #ececec;
            }

            &:last-of-type {
              margin-right: 0;

              &::after {
                display: none;
              }
            }
          }
        }
        .desc{
          font-size: 13px;
          font-weight: 400;
          color: #606060;
          line-height: 14px;
          width: 440px;
          overflow: hidden;
          white-space:nowrap;
          text-overflow: ellipsis;
        }
      }
      .interpolate-jobs{
        padding: 14px 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .job-num{
          font-size: 18px;
          font-weight: 500;
          color: #404040;
          line-height: 14px;
          letter-spacing: 2px;
        }
        .job-desc{
          font-size: 14px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 14px;
          text-align: center;
        }
        &::after{
          content: "";
          width: 1px;
          height: 35px;
          top: 17px;
          position: absolute;
          right: 0px;
          background-color: #ececec;
        }
        &:last-child{
          padding-right: 0;
          &::after{
            content: "";
            width: 0;
          }
        }
      }
    }
    .welfare-tag-box{
      display: flex;
      flex-wrap: wrap;
      height: 24px;
      overflow: hidden;
      margin-top: 10px;
      margin-bottom: 6px;
      width: 644px;
      margin-left: 86px;
      .welfare-tag-item{
        padding: 5px 12px;
        background: rgba(255, 159, 0, 0.08);
        border-radius: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #D59960;
        line-height: 14px;
        text-align: center;
        margin-right: 12px;
      }
    }
  }
</style>
